module.exports = __webpack_public_path__ + "img/receive-icon.08933010.svg";